import React, { ComponentProps } from "react";

function FlameIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={14}
      height={20}
      viewBox="0 0 14 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="fire-flame-curved 1" clipPath="url(#clip0_68_81294)">
        <path
          id="Vector"
          d="M7.875 1.82103C7.875 1.82096 7.87493 1.82085 7.87493 1.82078C7.87493 1.82063 7.87485 1.82063 7.87485 1.82049C7.87456 1.28229 7.44421 0.952231 7 0.951174C6.8934 0.950882 6.78887 0.986137 6.68639 1.02544C6.6862 1.02551 6.68591 1.02551 6.68569 1.02559H6.68555H6.68547H6.6854C6.67709 1.02894 6.66823 1.03 6.65984 1.03193C6.66837 1.03029 6.67716 1.02901 6.68533 1.02559C6.5271 1.08647 6.37835 1.17995 6.26515 1.3454C1.75 7.94549 8.16667 8.24284 8.16667 11.4512C8.16667 12.75 7.10482 13.801 5.80256 13.7839C4.5197 13.768 3.5 12.6987 3.5 11.4164V8.29924C3.5 7.50799 2.53498 7.12404 1.98924 7.69768C1.01398 8.72249 0 10.4788 0 12.6178C0 16.4779 3.13997 19.6178 7 19.6178C10.86 19.6178 14 16.4779 14 12.6178C14 6.4091 7.875 5.58138 7.875 1.82103ZM1.99011 7.69717C1.98982 7.69746 1.98953 7.69753 1.98924 7.69782C1.9896 7.69746 1.98997 7.69731 1.99033 7.69695L1.99011 7.69717ZM7 17.2849C5.40703 17.2849 3.9978 16.4826 3.15543 15.2607C3.93517 15.8152 4.86048 16.1178 5.83392 16.1178C8.40678 16.1178 10.5 14.0245 10.5 11.4515C10.5 9.33965 9.15483 8.03255 8.17265 7.07825C8.70862 7.43372 11.6667 9.35333 11.6667 12.6181C11.6667 15.1914 9.57323 17.2849 7 17.2849Z"
        />
        <path
          id="Vector_2"
          opacity="0.4"
          d="M7.01644 17.2848C5.42347 17.2848 4.01424 16.4824 3.17188 15.2606C3.95157 15.8151 4.87696 16.1177 5.85036 16.1177C8.42322 16.1177 10.5164 14.0244 10.5164 11.4513C10.5164 9.33953 9.17128 8.03242 8.18909 7.07812C8.72506 7.43359 11.6831 9.3532 11.6831 12.618C11.6831 15.1913 9.58967 17.2848 7.01644 17.2848Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_68_81294">
          <rect
            width={14}
            height="18.6667"
            fill="white"
            transform="translate(0 0.951172)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FlameIcon;
